<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jbcge4/tc-custom/9781631955617.jpg?1716663322138" alt="This image is the cover for the book Wild & Well"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wild & Well
      </h1>
      <p class="bookDescription body article font2">
        <b>What “shines through” in this wellness guide from a nurse practitioner “are the solutions she’s found . . . beyond common and conventional medical approaches” —<i>Kirkus Reviews</i></b><br/>  <br/> In a time when there is access to more knowledge and resources than ever before, a strange thing is happening: People still believe most of what they hear. Sadly, the idea that one has to feel worse and take more prescriptions as they age is just a lie, plain and simple. It’s a lie that has kept people stuck not in a healthcare system but in a sick-care system that doesn't profit from happy, healthy patients. Dani Williamson helps readers break free from that untruth and allow them to re-discover how they were meant to live<b> . . . </b><i>Wild &amp; Well</i>!<br/> In <i>Wild &amp; Well</i>, readers dive with Dani into a discussion of the modern state of health in America and learn the six steps they can take into order to reclaim their health, relationships, intimacy with their spouse, and faith in the fact that they are fearfully and wonderfully made. Readers learn that it’s not as hard as they think to eat well, sleep well, poop well, move well, relax well, and connect well.<br/>  <br/> “Dani expertly unpacks why we can’t think about our health in isolation—and why the best solution isn’t always medication. If you’re ready for a holistic, practical approach to your health, read on.” —Michael Hyatt, <i>New York Times</i>–bestselling author of <i>Your Best Year</i><br/>  <br/> “You will be inspired to living your wildest and most well life thanks to Dani’s wit, wisdom, and research.” —J Virgin, <i>New York Times</i>–bestselling author of <i>The Virgin Diet</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dani Williamson, Jennifer Lill Brown, Josh Axe
      </h2>
      
      <p class="authorDescription body article"><B>Dani Williamson</B> is a Family Nurse Practitioner with a thriving functional medicine practice called Integrative Family Medicine located in Franklin, Tennessee. Dani is living, walking, breathing proof that there is vibrant life after a “lifelong” diagnosis is handed down to you. For decades, Dani suffered from Irritable Bowel Syndrome, Lupus and on and off depression, it wasn’t until after graduating from Vanderbilt and working in a naturally minded medical practice that a medical professional asked her a life changing question: “Dani, what are you eating? Don’t you know that your diet controls your disease?” But no, Dani did not know this, and she had never even heard this during nurse practitioner school. From that moment on, she has been on a tireless pursuit to transform her patient’s lives through her six rules: eat well, sleep well, poop well, move well, relax well, and commune well. Today, she sees hundreds of patients every month in her clinic and  reaches thousands of others through her Instagram as well as her weekly Facebook Live health show and private Facebook community with over 10,000 members.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13d3e07b